import { Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { Observable, map } from 'rxjs';
import
  {
    Project,
    TranslocoClient,
    TranslocoMeta,
  } from 'src/NSwag/nswag-api-translation';

@Injectable({
  providedIn: 'root',
})
export class TranslocoHttpLoader implements TranslocoLoader
{
  constructor(private translocoClient: TranslocoClient) { }

  getTranslation(lang: string): Observable<Translation>
  {
    return this.translocoClient
      .getTranslations(
        new TranslocoMeta({
          project: Project.Application,
          module: 'vacancy',
          lang: lang,
        })
      )
      .pipe(
        map(result =>
        {
          let translation: Translation = {};
          result?.forEach(
            keyValue => (translation[keyValue.key] = keyValue.value)
          );
          return translation;
        })
      );
  }
}
